export type ZoomHotkeyAction = 'reset' | 'zoomIn' | 'zoomOut'

export function isEditableKeyTarget(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement ||
    (target instanceof HTMLElement && target.isContentEditable)
  )
}

export function zoomHotkeyAction(
  event: KeyboardEvent
): ZoomHotkeyAction | null {
  if (event.code === 'Space') return 'reset'
  if (event.key === '=' || event.key === '+') return 'zoomIn'
  if (event.key === '-' || event.key === '_') return 'zoomOut'
  return null
}
